// Define breakpoints in priority order (largest to smallest for proper cascade)
export const BREAKPOINT_ORDER = [
  'isMinWidthDesktopL',
  'isMinWidthDesktop',
  'isMinWidthLaptop',
  'isMinWidthTablet',
  'isMinWidthMobileL',
  'isMinWidthMobileM',
  'isMinWidthMobileS',
  'isMinWidthMobileXs',
  'isMinWidthMobileXxs',
  'isMobileSized',
  'isMinHeightMobileXs',
] as const

type BreakpointRange = (typeof BREAKPOINT_ORDER)[number]

export type BreakpointRangeKeys<T> = { [K in BreakpointRange]?: T }

export type ResponsiveBreakpoints = Required<BreakpointRangeKeys<boolean>>
